import { assign } from 'xstate';
import { Context } from '../filtersMachine';
import { createDefaultFilters } from '../defaultFilters';

const clearFilters = assign<Context, any>({
    filters: () => createDefaultFilters(),
});

export default clearFilters;
